export default "__VITE_ASSET__f5d9248b__"